<template>
  <div class="f-row flex-wrap">
    <div class="aling-i-s flex gap-6 m-left">
      <MainLogin class="center" />
      <ThemeSwitcher class="z-1000 p-0 pointer op-30-hover tr-all-03" />
    </div>
  </div>
</template>

<script setup>
// src/components/navigation/MenuNavigation.vue
import { useRouter, useRoute } from 'vue-router'
import { useI18n } from 'vue-i18n'
import ThemeSwitcher from '@/components/global/extras/ThemeSwitcher.vue'
import MainLogin from './MainLogin.vue'

const { t } = useI18n()
const router = useRouter()
const route = useRoute()
</script>
